import { api, ApiResponse, authHeader } from '@you-go-vn/components';
import { DiscountType, PromotionDetail, RuleOr } from '../data';

const genPromotionsAPI = (restaurantId: number) =>
  `/api/restaurants/${restaurantId}/promotions`;
type Item = PromotionDetail;
type Data = {
  items: Item[];
  total: number;
  totalPage: number;
};

type GetParams = {
  page?: number;
  limit?: number;
  keywords?: string;
};
const get = async (restaurantId: number, params?: GetParams) => {
  return api.get<ApiResponse<Data>>(genPromotionsAPI(restaurantId), {
    params: params,
    headers: authHeader(),
  });
};
const getById = async (restaurantId: number, id: number) => {
  return api.get<ApiResponse<PromotionDetail>>(
    genPromotionsAPI(restaurantId) + '/' + id,
    {
      headers: authHeader(),
    },
  );
};

export type AddParams = {
  code: string;
  name: string;
  description: string;
  startsFrom: Date;
  endTill: Date;
  numberCanCombined?: number;
  onlyInPromotion?: boolean;
  canJoinPromotion?: boolean;
  limitUsesPerCode?: number;
  limitUsesPerUser?: number;
  limitUsesPerCodeInDate?: number;
  limitUsesPerUserInDate?: number;
  rules: RuleOr[];
  discountType: DiscountType;
  discountAmount: number;
  discountMax?: number;
  isActive: boolean;
  isPublic: boolean;
  order?: number;
};
const add = async (restaurantId: number, body: AddParams) => {
  return api.post<ApiResponse<Item>>(genPromotionsAPI(restaurantId), body, {
    headers: authHeader(),
  });
};

type UpdateParams = Partial<AddParams>;
const update = async (restaurantId: number, id: number, body: UpdateParams) => {
  return api.put<ApiResponse<{ success: boolean }>>(
    genPromotionsAPI(restaurantId) + '/' + id,
    body,
    {
      headers: authHeader(),
    },
  );
};

const remove = async (restaurantId: number, id: number) => {
  return api.delete<ApiResponse<{ success: boolean }>>(
    genPromotionsAPI(restaurantId) + '/' + id,
    {
      headers: authHeader(),
    },
  );
};

export const promotionServices = {
  get,
  getById,
  add,
  update,
  remove,
};
